import  { useState, useEffect } from 'react';
import '../../styles/about/stats.css';

// 1. Helper Component for the Number Animation
const Counter = ({ end, duration = 2000 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime = null;
    const start = 0;

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = currentTime - startTime;
      const current = Math.min(
        Math.floor((progress / duration) * (end - start) + start),
        end
      );
      setCount(current);
      if (progress < duration) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }, [end, duration]);

  return <span>{count.toLocaleString()}</span>;
};

const StatsSection = () => {
  const statsData = [
    { number: 12, label: "Years of consistent teaching excellence" },
    { number: 2000, label: "Students trained in India and abroad" },
    { number: 500, label: "Alumni in Big 4, MNCs & top corporates" },
    { number: 90, label: "Pass rates in key professional courses", isPercent: true }
  ];

  return (
    <section className="stats-section">
      {/* 1. Dark Overlay */}
      <div className="stats-overlay"></div>

      {/* 2. Content Container */}
      <div className="container stats-content">
        <div className="row">
          {statsData.map((stat, index) => (
            <div key={index} className="col-6 col-md-3 text-center mb-4 mb-md-0">
              <div className="stat-item">
                <h2 className="display-4 fw-bold text-white mb-2">
                  <Counter end={stat.number} />
                  <span className="plus-sign">{stat.isPercent ? '%' : '+'}</span>
                </h2>
                <p className="text-white-50 small text-uppercase fw-semibold px-2">
                  {stat.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;